/* Fidget Critter pop-ups (BOLD draft): 7-minute 15%-off-eligible-toys coupon + cart nudge.
   Oct 25: nudge no longer fires after coupon dismiss; requires cart≥1 + 60s idle (no further adds).
   Offer switched from free shipping to 15% off eligible toys at 11:44 AM MT Oct 24 (code in data-code on #fc-popups).
   ---- Easy-change constants ---- */
var FC_POPUP_DELAY_SECONDS = 45;   /* seconds of ACTIVE browsing before the coupon shows */
var FC_COUPON_SECONDS = 420;       /* 7:00 coupon countdown */
var FC_NUDGE_SECONDS = 300;        /* 5:00: "Just $X.XX away" line on the coupon AND the cart-nudge offer */
var FC_FREE_SHIP_MIN = 35;         /* coupon threshold, dollars of ELIGIBLE toys (Shopify enforces this on the code too) */
var FC_NUDGE_GOAL = 40;            /* extension / cart-nudge goal, dollars of ELIGIBLE toys (enforced by this script) */
var FC_IDLE_SECONDS = 15;          /* activity older than this does not count as active */
var FC_CART_IDLE_SECONDS = 60;     /* Oct 25: nudge only after cart has ≥1 item AND this many seconds with no further adds (no post-coupon timer) */
var FC_ENDED_SECONDS = 4;           /* non-clicker / fallback: how long the pill says "15% off offer ended" */
var FC_EXT_SECONDS = 15;           /* clickers: extension message shown at coupon 0:00 */
var FC_EXT_SECONDS_X40 = 300;      /* clickers: 5:00 window after the message; the $35 code stays only while cart >= FC_NUDGE_GOAL */
var FC_TERMS_URL = '/pages/free-shipping-terms';   /* full pop-up offer terms (handle kept so links don't break; hidden until Zoran publishes it) */
/* Zoran's exact extension copy, latest 10:40 AM MT (heading + body together = his sentence). */
var FC_EXT_HEADER = 'Time\'s up on that one.';
var FC_EXT_BODY = 'Wanna try again? Add five more dollars to get five more minutes for your 15% off.';
/* nudge copy for visitors who did NOT click "Shop now" (no offer). Swap freely. */
var FC_NUDGE_PLAIN_HEADER = 'Almost there, critter friend!';
var FC_NUDGE_PLAIN_BODY = 'Here are a few critter buddies that go great with your cart.';
/* ---- Offer EXCLUSIONS (Zoran, 11:09 AM MT Oct 24; kept for the 15% switch): edit these lists to change what is excluded ----
   Excluded cart lines do NOT count toward the $35 (coupon) / $40 (extension + nudge) minimums,
   and excluded products are never suggested in the nudge. Matching is case-insensitive.
   NOTE: Shopify enforces the code itself: it only discounts products in the internal smart collection
   "Pop-up 15% eligible (internal)" (type Toys, minus excluded tags/titles) and counts only those toward its $35 minimum.
   Keep these lists in step with that collection's rules. The $40 extension rule is enforced only by this script. */
var FC_ELIGIBLE_TYPES = ['Toys'];   /* only these product types count (mirrors the collection's TYPE = Toys rule); [] = any type */
var FC_EXCLUDED_TYPES = ['Birthday Bag', 'Engraved Slate', 'Laser Cut Acrylic'];   /* exact product types */
var FC_EXCLUDED_TAGS = ['birthday-bag-tier', 'slate', 'laser-cut', 'laser', 'laser-engraved', 'acrylic', 'engraving', 'engraved', 'custom color', 'custom', 'custom-color', 'custom print', 'custom-print', 'quote'];   /* exact product tags */
var FC_EXCLUDED_WORDS = ['laser', 'engrav', 'birthday-bag', 'build-a-bag', 'build-a-birthday', 'custom', 'quote'];   /* 'custom'/'quote' added 11:49: custom color / custom print / quoted orders */   /* found anywhere in handle, tags or line-item property names */
var FC_FINE_PRINT = 'Not valid on Build-a-Bag, custom engraving or laser-made items.';

(function(){
  'use strict';
  if (window.FC_POPUPS) return;
  var root = document.getElementById('fc-popups');
  if (!root || !window.HTMLDialogElement) return;
  var FC = window.FC_POPUPS = {};
  var SS = window.sessionStorage;
  function get(k){ try { return SS.getItem(k); } catch(e){ return null; } }
  function set(k,v){ try { SS.setItem(k, String(v)); } catch(e){} }
  function del(k){ try { SS.removeItem(k); } catch(e){} }
  var K = { ms:'fc_cp_active_ms', st:'fc_cp_state', end:'fc_cp_end', away:'fc_cp_away_end', nst:'fc_nd_state', nend:'fc_nd_end', ndue:'fc_nd_due' };
  var QS = new URLSearchParams(location.search);
  var debug = (QS.get('fc_popup') || '').toLowerCase();
  if (debug === 'reset') Object.keys(K).forEach(function(k){ del(K[k]); });
  /* test switch: ?fc_popup=now&fc_test_secs=20 starts the coupon with a shorter countdown (can only shorten) */
  var testSecs = Math.min(FC_COUPON_SECONDS, Math.max(5, parseInt(QS.get('fc_test_secs') || '0', 10) || FC_COUPON_SECONDS));
  /* test switches (can only shorten): &fc_test_ext=5 (extension message secs), &fc_test_x40=20 ($40 window secs) */
  var extSecs = Math.min(FC_EXT_SECONDS, Math.max(3, parseInt(QS.get('fc_test_ext') || '0', 10) || FC_EXT_SECONDS));
  var x40Secs = Math.min(FC_EXT_SECONDS_X40, Math.max(10, parseInt(QS.get('fc_test_x40') || '0', 10) || FC_EXT_SECONDS_X40));

  var D = root.dataset;
  var POPUPS = D.popups === 'true';
  var CODE = D.code || '';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function now(){ return Date.now(); }
  function mmss(ms){ var s = Math.max(0, Math.ceil(ms/1000)); return Math.floor(s/60) + ':' + ('0' + (s % 60)).slice(-2); }
  function money(c){ return '$' + (Math.max(0, c)/100).toFixed(2); }
  function esc(t){ var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  var rawFetch = window.fetch.bind(window);
  /* ---------- offer eligibility (excluded lines don't count; see config at the top) ---------- */
  var okTypes = FC_ELIGIBLE_TYPES.map(function(t){ return String(t).trim().toLowerCase(); });
  var exTypes = FC_EXCLUDED_TYPES.map(function(t){ return String(t).trim().toLowerCase(); });
  var exTags = FC_EXCLUDED_TAGS.map(function(t){ return String(t).trim().toLowerCase(); });
  var exWords = FC_EXCLUDED_WORDS.map(function(t){ return String(t).trim().toLowerCase(); }).filter(Boolean);
  function hasWord(txt){ txt = String(txt || '').toLowerCase(); return exWords.some(function(w){ return txt.indexOf(w) > -1; }); }
  function isExcluded(type, tags, handle, extra){
    tags = (tags || []).map(function(t){ return String(t).trim().toLowerCase(); });
    var ty = String(type || '').trim().toLowerCase();
    if (exTypes.indexOf(ty) > -1) return true;
    if (okTypes.length && okTypes.indexOf(ty) < 0) return true;
    if (tags.some(function(t){ return exTags.indexOf(t) > -1; })) return true;
    return hasWord(handle) || hasWord(tags.join(',')) || hasWord(extra);
  }
  FC.isExcluded = isExcluded;
  var tagCache = {};   /* handle -> tags (cart.js has no tags, so read /products/<handle>.js once per visit) */
  try { tagCache = JSON.parse(SS.getItem('fc_ptags') || '{}') || {}; } catch(e){ tagCache = {}; }
  function tagsFor(handle){
    if (!handle) return Promise.resolve([]);
    if (tagCache[handle]) return Promise.resolve(tagCache[handle]);
    return rawFetch('/products/' + encodeURIComponent(handle) + '.js', { headers:{Accept:'application/json'}, credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.json() : { tags: [] }; })
      .then(function(p){
        var t = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
        tagCache[handle] = t; try { SS.setItem('fc_ptags', JSON.stringify(tagCache)); } catch(e){}
        return t;
      }).catch(function(){ return []; });
  }
  function lineExcluded(i){
    var props = i.properties ? Object.keys(i.properties).join(' ') : '';
    if (isExcluded(i.product_type, [], i.handle, props)) return Promise.resolve(true);
    return tagsFor(i.handle).then(function(t){ return isExcluded(i.product_type, t, i.handle, props); });
  }
  /* adds c.fc_eligible (cents) + c.fc_excluded (handles) to a /cart.js result */
  function withEligible(c){
    var items = (c && c.items) || [];
    return Promise.all(items.map(lineExcluded)).then(function(ex){
      var full = c.items_subtotal_price != null ? c.items_subtotal_price : c.total_price;
      var elig = 0, out = [];
      items.forEach(function(i, n){
        var lp = i.final_line_price != null ? i.final_line_price : i.line_price;
        if (ex[n]) out.push(i.handle); else elig += lp || 0;
      });
      c.fc_eligible = Math.max(0, Math.min(full, elig)); c.fc_excluded = out;
      FC.eligible = { full: full, eligible: c.fc_eligible, excluded: out };
      return c;
    });
  }
  function getCart(){ return rawFetch('/cart.js', { headers:{Accept:'application/json'}, credentials:'same-origin' }).then(function(r){ return r.json(); }).then(withEligible); }
  FC.getCart = getCart;

  /* ---------- shared dialog helpers ---------- */
  var open = null; var queue = [];
  function sprout(bubble){
    return '<div class="fc-pop__sprout" aria-hidden="true"><img src="' + D.sprout + '" alt="" width="112" height="110" loading="eager"><span class="fc-pop__psst">' + esc(bubble) + '</span></div>';
  }
  function finePrint(){
    return '<p class="fc-pop__fine">' + esc(FC_FINE_PRINT) + ' See <a href="' + FC_TERMS_URL + '">full terms</a>.</p>';
  }
  function makeDialog(id, label, inner){
    var dlg = document.createElement('dialog');
    dlg.className = 'fc-pop' + (reduce ? ' fc-pop--still' : ''); dlg.id = id;
    dlg.setAttribute('aria-modal', 'true'); dlg.setAttribute('aria-labelledby', id + '-h');
    dlg.innerHTML = '<div class="fc-pop__card" role="document">' + inner + '</div>';
    dlg.addEventListener('cancel', function(e){ e.preventDefault(); dlg._dismiss && dlg._dismiss(); });
    dlg.addEventListener('click', function(e){ if (e.target === dlg) dlg._dismiss && dlg._dismiss(); });
    dlg.addEventListener('keydown', function(e){
      if (e.key !== 'Tab') return;
      var f = [].slice.call(dlg.querySelectorAll('button:not([disabled]), a[href]')).filter(function(x){ return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    return dlg;
  }
  function show(dlg){
    if (open && open !== dlg) { queue.push(dlg); return; }
    open = dlg; dlg._prev = document.activeElement;
    document.body.appendChild(dlg);           /* last in DOM + top layer => above everything */
    try { dlg.showModal(); } catch(e){ dlg.setAttribute('open', ''); }
    var c = dlg.querySelector('.fc-pop__x'); c && c.focus({ preventScroll:true });
  }
  function hide(dlg){
    try { dlg.close(); } catch(e){ dlg.removeAttribute('open'); }
    dlg.remove(); if (open === dlg) open = null;
    if (dlg._prev && dlg._prev.focus) { try { dlg._prev.focus({ preventScroll:true }); } catch(e){} }
    var n = queue.shift(); if (n && n._resume) n._resume();
  }

  /* ---------- 1) coupon: shows after FC_POPUP_DELAY_SECONDS of active browsing ---------- */
  var cp = null, cpTimer = null;
  function couponDone(){ var s = get(K.st); return s === 'dismissed' || s === 'expired' || s === 'clicked'; }
  function buildCoupon(){
    var inner =
      sprout('psst!') +
      '<button type="button" class="fc-pop__x" aria-label="Close offer"><span aria-hidden="true">&times;</span></button>' +
      '<p class="fc-pop__kicker">A little critter deal</p>' +
      '<h2 class="fc-pop__h" id="fc-coupon-h">15% off is yours</h2>' +
      '<p class="fc-pop__sub fc-pop__body">Order within the next <span class="fc-pop__timer fc-pop__timer--inline" role="timer" aria-live="off"><span class="fc-pop__clock" data-clock>7:00</span></span> to get 15% off eligible toys when you spend $' + FC_FREE_SHIP_MIN + ' or more on them.</p>' +
      '<p class="fc-pop__away" data-away hidden></p>' +
      '<a class="fc-pop__btn" href="' + (D.shopUrl || '/collections/all') + '">Shop now</a>' +
      '<button type="button" class="fc-pop__nah">Nah, I\'m good</button>' + finePrint();
    var dlg = makeDialog('fc-coupon', '15% off offer', inner);
    dlg._dismiss = function(){ set(K.st, 'dismissed'); stopCoupon(); };
    dlg.querySelector('.fc-pop__btn').addEventListener('click', onShopNow);
    dlg.querySelector('.fc-pop__x').addEventListener('click', dlg._dismiss);
    dlg.querySelector('.fc-pop__nah').addEventListener('click', dlg._dismiss);
    dlg._resume = function(){ startCoupon(); };
    return dlg;
  }
  /* Oct 25: do NOT schedule nudge from coupon dismiss/expiry. Nudge arms only via armIdleNudge after a cart add. */
  function scheduleNudge(at){ /* disabled — kept as no-op so any leftover call sites are harmless */ }
  function stopCoupon(){ clearInterval(cpTimer); cpTimer = null; if (cp) { var d = cp; cp = null; hide(d); } }
  var awayCents = null;
  function renderCoupon(){
    if (!cp) return;
    var left = (+get(K.end) || 0) - now();
    if (left <= 0) { set(K.st, 'expired'); stopCoupon(); return; }
    cp.querySelector('[data-clock]').textContent = mmss(left);
    var a = cp.querySelector('[data-away]'), aleft = (+get(K.away) || 0) - now();
    if (awayCents != null && awayCents > 0 && aleft > 0) {
      a.hidden = false;
      a.innerHTML = 'Just <strong>' + money(awayCents) + '</strong> away from 15% off. Top up in the next <strong>' + mmss(aleft) + '</strong>';
    } else a.hidden = true;
  }
  function refreshAway(){
    return getCart().then(function(c){
      var sub = subOf(c);   /* eligible subtotal: excluded items don't count toward $35 */
      awayCents = (c.item_count > 0 && sub < FC_FREE_SHIP_MIN * 100) ? FC_FREE_SHIP_MIN * 100 - sub : null;
      renderCoupon();
    }).catch(function(){});
  }
  function startCoupon(){
    if (couponDone()) return;
    if (get(K.st) !== 'open') { set(K.st, 'open'); set(K.end, now() + testSecs * 1000); set(K.away, now() + Math.min(testSecs, FC_NUDGE_SECONDS) * 1000); }
    if ((+get(K.end) || 0) <= now()) { set(K.st, 'expired'); return; }
    if (!cp) cp = buildCoupon();
    if (open && open !== cp) { if (queue.indexOf(cp) < 0) queue.push(cp); return; }
    show(cp); renderCoupon(); refreshAway();
    clearInterval(cpTimer); cpTimer = setInterval(renderCoupon, 250);
  }
  FC.showCoupon = startCoupon;

  /* active-time tracking (only while visible and interacted with in the last FC_IDLE_SECONDS) */
  var lastAct = now();
  ['pointerdown','pointermove','mousemove','keydown','scroll','wheel','touchstart','click'].forEach(function(ev){
    window.addEventListener(ev, function(){ lastAct = now(); }, { passive:true, capture:true });
  });
  function tick(){
    var due = +get(K.ndue) || 0;
    if (due && now() >= due && !nudgeDone() && get(K.nst) !== 'open' && !open) { del(K.ndue); dueNudge(); }
    if (couponDone() || get(K.st) === 'open' || get(K.st) === 'clicked') return;
    if (document.visibilityState === 'visible' && now() - lastAct < FC_IDLE_SECONDS * 1000) {
      var ms = (+get(K.ms) || 0) + 1000; set(K.ms, ms);
      if (ms >= FC_POPUP_DELAY_SECONDS * 1000) startCoupon();
    }
  }

  /* ---------- 2) cart nudge: after an add-to-cart leaves the cart under FC_NUDGE_GOAL ---------- */
  var nd = null, ndTimer = null, ndCart = null;
  function nudgeDone(){ var s = get(K.nst); return s === 'dismissed' || s === 'expired' || s === 'won' || s === 'skipped' || s === 'plain'; }
  function dueNudge(){
    getCart().then(function(c){
      if (!c || c.item_count < 1) { del(K.ndue); return; }                       /* must have ≥1 item */
      if (subOf(c) >= FC_NUDGE_GOAL * 100) { set(K.nst, 'skipped'); return; }   /* already $40+ */
      startNudge(c);
    }).catch(function(){});
  }
  /* Arm / reset the 60s idle timer after any successful cart add (or when cart already has items on boot). */
  function armIdleNudge(){
    if (nudgeDone() || get(K.nst) === 'open') return;
    getCart().then(function(c){
      if (!c || c.item_count < 1) { del(K.ndue); return; }
      if (subOf(c) >= FC_NUDGE_GOAL * 100) { set(K.nst, 'skipped'); del(K.ndue); return; }
      set(K.ndue, now() + FC_CART_IDLE_SECONDS * 1000);                          /* reset idle on every add */
    }).catch(function(){});
  }
  function isClicker(){ var f = lget(FS.st); return get(K.st) === 'clicked' || f === 'active' || f === 'ext' || f === 'x40'; }
  function buildPlainNudge(){
    var inner =
      sprout('psst!') +
      '<button type="button" class="fc-pop__x" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
      '<h2 class="fc-pop__h" id="fc-nudge-h">' + esc(FC_NUDGE_PLAIN_HEADER) + '</h2>' +
      '<p class="fc-pop__sub fc-pop__body">' + esc(FC_NUDGE_PLAIN_BODY) + '</p>' +
      '<div class="fc-pop__recs" data-recs aria-label="Suggested critters" role="list"><p class="fc-pop__loading">Finding critter buddies&hellip;</p></div>' +
      '<a class="fc-pop__btn" href="' + (D.cartUrl || '/cart') + '" data-nd-cart>View cart</a>' +
      '<button type="button" class="fc-pop__nah">Nah, I\'m good</button>';
    var dlg = makeDialog('fc-nudge', 'Suggestions', inner);
    dlg.classList.add('fc-pop--nudge', 'fc-pop--plain');
    dlg._plain = true;
    dlg._dismiss = function(){ stopNudge(); };
    dlg.querySelector('.fc-pop__x').addEventListener('click', dlg._dismiss);
    dlg.querySelector('.fc-pop__nah').addEventListener('click', dlg._dismiss);
    dlg._resume = function(){ show(dlg); };
    dlg.addEventListener('click', onAddClick);
    return dlg;
  }
  function buildNudge(){
    var inner =
      sprout('so close!') +
      '<button type="button" class="fc-pop__x" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
      '<h2 class="fc-pop__h" id="fc-nudge-h">Almost there, critter friend!</h2>' +
      '<div data-nd-body>' +
        '<p class="fc-pop__togo"><strong data-nd-togo>$0.00</strong> to go</p>' +
        '<p class="fc-pop__sub fc-pop__body">You\'re so close! Get your eligible toys to $' + FC_NUDGE_GOAL + ' and your 15% off comes back. This offer ends in <span class="fc-pop__timer fc-pop__timer--inline" role="timer" aria-live="off"><span class="fc-pop__clock" data-clock>5:00</span></span>.</p>' +
        '<div class="fc-pop__recs" data-recs aria-label="Suggested critters" role="list"><p class="fc-pop__loading">Finding critter buddies&hellip;</p></div>' +
      '</div>' +
      '<div class="fc-pop__won" data-nd-won hidden role="status"><p class="fc-pop__sub"><strong>You did it!</strong> 15% off is yours on your eligible toys.</p></div>' +
      '<a class="fc-pop__btn" href="' + (D.cartUrl || '/cart') + '" data-nd-cart>View cart</a>' +
      '<button type="button" class="fc-pop__nah">Nah, I\'m good</button>' + finePrint();
    var dlg = makeDialog('fc-nudge', 'Almost there', inner);
    dlg.classList.add('fc-pop--nudge');
    dlg._dismiss = function(){ if (get(K.nst) !== 'won') set(K.nst, 'dismissed'); stopNudge(); };
    dlg.querySelector('.fc-pop__x').addEventListener('click', dlg._dismiss);
    dlg.querySelector('.fc-pop__nah').addEventListener('click', dlg._dismiss);
    dlg._resume = function(){ startNudge(); };
    dlg.addEventListener('click', onAddClick);
    return dlg;
  }
  function stopNudge(){ clearInterval(ndTimer); ndTimer = null; if (nd) { var d = nd; nd = null; hide(d); } }
  /* ELIGIBLE subtotal (excluded lines removed) when known; used for every $35 / $40 check in this file.
     Shopify itself still checks the code's $35 minimum against the full subtotal at checkout. */
  function subOf(c){ if (c && c.fc_eligible != null) return c.fc_eligible; return c.items_subtotal_price != null ? c.items_subtotal_price : c.total_price; }
  function renderNudge(){
    if (!nd || nd._plain) return;
    if (get(K.nst) === 'won') return;
    var left = (+get(K.nend) || 0) - now();
    if (left <= 0) { set(K.nst, 'expired'); stopNudge(); return; }
    nd.querySelector('[data-clock]').textContent = mmss(left);
    if (ndCart) nd.querySelector('[data-nd-togo]').textContent = money(FC_NUDGE_GOAL * 100 - subOf(ndCart));
  }
  function startNudge(cart){
    if (nudgeDone()) return;
    if (!isClicker()) {                         /* non-clickers: suggestions only, no offer/timer/pill */
      set(K.nst, 'plain');                      /* shown once per visit, not resumed on other pages */
      if (!nd) nd = buildPlainNudge();
      if (open && open !== nd) { if (queue.indexOf(nd) < 0) queue.push(nd); return; }
      show(nd);
      (cart ? Promise.resolve(cart) : getCart()).then(function(c){ ndCart = c; loadRecs(c); });
      return;
    }
    if (get(K.nst) !== 'open') { set(K.nst, 'open'); set(K.nend, x40Exp() || (now() + FC_NUDGE_SECONDS * 1000)); }
    if ((+get(K.nend) || 0) <= now()) { set(K.nst, 'expired'); return; }
    if (!nd) nd = buildNudge();
    if (open && open !== nd) { if (queue.indexOf(nd) < 0) queue.push(nd); return; }
    show(nd); renderNudge();
    clearInterval(ndTimer); ndTimer = setInterval(renderNudge, 250);
    (cart ? Promise.resolve(cart) : getCart()).then(function(c){ ndCart = c; renderNudge(); loadRecs(c); });
  }
  FC.showNudge = startNudge;
  function maybeNudge(){
    /* Oct 25: cart add only arms the 60s idle timer; does not open the nudge immediately */
    if (nudgeDone() || get(K.nst) === 'open') return;
    armIdleNudge();
  }
  /* notice adds made by the theme (fetch to /cart/add) and classic form posts redirect to /cart, which is excluded */
  window.fetch = (function(prev){
    return function(input, init){
      var p = prev.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function(){ setTimeout(syncCode, 400); }, function(){});
        if (POPUPS && /\/cart\/add/.test(u) && !(init && init.headers && init.headers['X-FC-Nudge'])) p.then(function(r){ if (r && r.ok) setTimeout(maybeNudge, 600); }, function(){});
      } catch(e){}
      return p;
    };
  })(window.fetch);

  /* ---------- suggestions ---------- */
  var DENY = /engrav|laser|personaliz|custom|build-a-bag|birthday-bag|\bbags?\b|bump|bruise|mystery|gift ?card|giftcard|service|print-to-order|final sale/i;
  var TOY = /toy|fidget|flexi|critter|keychain|dragon|mini|skeleton|collectible|articulated/i;
  function norm(p){
    if (!p || !p.variants) return null;
    var cents = function(v){ return typeof v === 'number' ? v : Math.round(parseFloat(v || '0') * 100); };
    var vars = p.variants.map(function(v){ return { id:v.id, available: v.available !== false, price: cents(v.price) }; });
    var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    if (img && typeof img === 'object') img = img.src || img.url || '';
    var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
    return { id:p.id, handle:p.handle, title:p.title, type: p.type || p.product_type || '', vendor: p.vendor || '', tags: tags.map(function(t){ return String(t).trim(); }),
             url: (p.url || ('/products/' + p.handle)).split('?')[0], img: img, vars: vars,
             multi: vars.length > 1 && !(p.options && p.options.length === 1 && /^title$/i.test(p.options[0].name || p.options[0])) };
  }
  function isPto(v){ return !!(window.FC_PTO && window.FC_PTO.isPto && window.FC_PTO.isPto(v)); }
  function allowed(p, inCart){
    if (!p || inCart[p.id]) return false;
    var hay = [p.handle, p.title, p.type, p.vendor, p.tags.join(',')].join(' ');
    if (DENY.test(hay)) return false;
    if (isExcluded(p.type, p.tags, p.handle, p.title)) return false;   /* never suggest excluded items */
    if (!(/^toys?$/i.test(p.type) || TOY.test(p.tags.join(',') + ' ' + p.title))) return false;
    if (p.vars.some(function(v){ return isPto(v.id); })) return false;
    var av = p.vars.filter(function(v){ return v.available && v.price > 0; });
    if (!av.length) return false;
    p.v = av[0]; return true;
  }
  FC.filter = function(p){ return allowed(norm(p), {}); };
  function recs(pid, intent){
    var u = (D.recs || '/recommendations/products') + '.json?product_id=' + pid + '&limit=4&intent=' + intent;
    return rawFetch(u, { credentials:'same-origin' }).then(function(r){ return r.ok ? r.json() : { products: [] }; }).then(function(j){ return j.products || []; }).catch(function(){ return []; });
  }
  function coll(h){
    return rawFetch((D.root || '/').replace(/\/$/, '') + '/collections/' + h + '/products.json?limit=50', { credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.json() : { products: [] }; }).then(function(j){ return j.products || []; }).catch(function(){ return []; });
  }
  /* bucket a product into a mix kind from title/tags/handle — no hardcoded product names */
  function kindOf(p){
    var hay = [p.handle, p.title, (p.tags || []).join(' ')].join(' ').toLowerCase();
    if (/skeleton/.test(hay)) return 'skeleton';
    if (/dragon/.test(hay) && !/keychain/.test(hay)) return 'dragon';
    /* Flexi Critters collection tag / flexi animals that aren't dragons or skeletons */
    if (/flexi critters|flexi-critters/.test(hay)) return 'flexi';
    if (/keychain/.test(hay)) return 'keychain';
    if (/\bmini\b|mini figure|pocket /.test(hay)) return 'mini';
    if (/\bflexi\b|articulated/.test(hay) && !/dragon/.test(hay)) return 'flexi';
    if (/critter/.test(hay)) return 'flexi';
    return 'other';
  }
  /* per-visit seed: same picks while the tab session lasts, new mix on the next visit */
  var EMPTY_SEED_KEY = 'fc_nudge_empty_seed';
  var EMPTY_PICKS_KEY = 'fc_nudge_empty_picks';
  function emptySeed(){
    try {
      var s = sessionStorage.getItem(EMPTY_SEED_KEY);
      if (s && +s) return (+s) >>> 0;
      var n = (Date.now() ^ Math.floor(Math.random() * 0x100000000)) >>> 0;
      if (!n) n = 1;
      sessionStorage.setItem(EMPTY_SEED_KEY, String(n));
      return n;
    } catch(e){ return (Math.floor(Math.random() * 0x100000000) || 1) >>> 0; }
  }
  function mulberry32(a){
    return function(){
      a |= 0; a = a + 0x6D2B79F5 | 0;
      var t = Math.imul(a ^ a >>> 15, 1 | a);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }
  function shuffle(arr, rand){
    var a = arr.slice();
    var rnd = typeof rand === 'function' ? rand : Math.random;
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(rnd() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }
  function restoreEmptyPicks(pool){
    try {
      var raw = sessionStorage.getItem(EMPTY_PICKS_KEY);
      if (!raw) return null;
      var handles = JSON.parse(raw);
      if (!Array.isArray(handles) || !handles.length) return null;
      var byH = {};
      pool.forEach(function(p){ byH[p.handle] = p; });
      var restored = [];
      handles.forEach(function(h){ if (byH[h]) restored.push(byH[h]); });
      return restored.length >= 2 ? restored.slice(0, 4) : null;
    } catch(e){ return null; }
  }
  function saveEmptyPicks(list){
    try { sessionStorage.setItem(EMPTY_PICKS_KEY, JSON.stringify(list.map(function(p){ return p.handle; }))); } catch(e){}
  }
  /* pick up to n products with different kinds (dragon / skeleton / flexi / keychain / mini) */
  function diversify(list, n, rand){
    var buckets = { dragon: [], skeleton: [], flexi: [], keychain: [], mini: [], other: [] };
    list.forEach(function(p){
      var k = kindOf(p);
      (buckets[k] || buckets.other).push(p);
    });
    Object.keys(buckets).forEach(function(k){ buckets[k] = shuffle(buckets[k], rand); });
    var prefer = shuffle(['dragon', 'skeleton', 'flexi', 'keychain', 'mini'], rand);
    var picked = [], used = {};
    function pull(k){
      var b = buckets[k] || [];
      while (b.length) {
        var p = b.shift();
        if (!used[p.id]) { used[p.id] = 1; picked.push(p); return true; }
      }
      return false;
    }
    for (var i = 0; i < prefer.length && picked.length < n; i++) pull(prefer[i]);
    var rest = [];
    Object.keys(buckets).forEach(function(k){ rest = rest.concat(buckets[k]); });
    rest = shuffle(rest, rand);
    for (var r = 0; r < rest.length && picked.length < n; r++) {
      if (!used[rest[r].id]) { used[rest[r].id] = 1; picked.push(rest[r]); }
    }
    return picked;
  }
  function loadRecs(cart){
    var box = nd && nd.querySelector('[data-recs]'); if (!box) return;
    var inCart = {}; (cart.items || []).forEach(function(i){ inCart[i.product_id] = 1; });
    var pids = Object.keys(inCart).slice(0, 4);
    var emptyCart = !pids.length;
    var seen = {}, out = [];
    function take(list){ list.map(norm).forEach(function(p){ if (p && !seen[p.id] && allowed(p, inCart)) { seen[p.id] = 1; out.push(p); } }); }
    Promise.all(pids.map(function(id){
      return recs(id, 'complementary').then(function(a){ return a.length ? a : recs(id, 'related'); });
    })).then(function(lists){ lists.forEach(take); })
    .then(function(){
      /* non-empty cart: keep complementary/related then best-sellers / under-10 fallbacks */
      if (!emptyCart) {
        return (out.length >= 2 ? Promise.resolve(null) : coll('best-sellers').then(take))
          .then(function(){ return out.length >= 2 ? null : coll('under-10').then(take); });
      }
      /* empty cart: wider mix of collections, then diversify by product kind */
      return Promise.all([
        coll('best-sellers'),
        coll('under-10'),
        coll('flexi-critters'),
        coll('skeleton'),
        coll('keychains'),
        coll('minis'),
        coll('fidget-toys')
      ]).then(function(lists){ lists.forEach(take); });
    })
    .then(function(){
      if (emptyCart) {
        var restored = restoreEmptyPicks(out);
        if (restored) {
          out = restored;
        } else {
          out = diversify(out, 4, mulberry32(emptySeed()));
          saveEmptyPicks(out);
        }
      } else {
        var gap = FC_NUDGE_GOAL * 100 - subOf(cart);
        out.sort(function(a, b){ return Math.abs(a.v.price - gap) - Math.abs(b.v.price - gap); });
        out = out.slice(0, 4);
      }
      FC.lastRecs = out.map(function(p){ return p.handle; });
      if (!out.length) { box.innerHTML = '<p class="fc-pop__loading">Browse more critters in the shop.</p>'; return; }
      box.innerHTML = out.map(function(p){
        var act = p.multi
          ? '<a class="fc-rec__add" href="' + esc(p.url) + '">View</a>'
          : '<button type="button" class="fc-rec__add" data-add="' + p.v.id + '">Add</button>';
        return '<div class="fc-rec" role="listitem"><a class="fc-rec__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
          (p.img ? '<img src="' + esc(String(p.img).replace(/^\/\//, 'https://')) + (String(p.img).indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="" loading="lazy" width="120" height="120">' : '') + '</a>' +
          '<a class="fc-rec__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="fc-rec__p">' + money(p.v.price) + '</span>' + act + '</div>';
      }).join('');
    });
  }
  function onAddClick(e){
    var b = e.target.closest && e.target.closest('[data-add]'); if (!b) return;
    e.preventDefault(); if (b.disabled) return;
    b.disabled = true; var t = b.textContent; b.textContent = 'Adding\u2026';
    window.fetch('/cart/add.js', { method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', Accept:'application/json', 'X-FC-Nudge':'1' },
      body: JSON.stringify({ items: [{ id: +b.getAttribute('data-add'), quantity: 1 }] }) })
      .then(function(r){ if (!r.ok) throw r; return getCart(); })
      .then(function(c){
        ndCart = c; syncCode(); b.textContent = 'Added!'; b.classList.add('is-added');
        var icon = document.querySelector('cart-icon');
        try { icon && icon.renderCartBubble && icon.renderCartBubble(c.item_count); } catch(x){}
        try { sessionStorage.setItem('cart-count', JSON.stringify({ value:String(c.item_count), timestamp:Date.now() })); } catch(x){}
        try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles:true, detail:{ resource:c, sourceId:'fc-nudge', data:{ itemCount:c.item_count, source:'fc-nudge' } } })); } catch(x){}
        if (nd && nd._plain) { /* no offer for non-clickers */ }
        else if (subOf(c) >= FC_NUDGE_GOAL * 100) {
          set(K.nst, 'won'); clearInterval(ndTimer);
          nd.querySelector('[data-nd-body]').hidden = true; nd.querySelector('[data-nd-won]').hidden = false;
          nd.querySelector('.fc-pop__psst').textContent = 'yay!';
          var cb = nd.querySelector('[data-nd-cart]'); cb && cb.focus();
        } else renderNudge();
      })
      .catch(function(){ b.disabled = false; b.textContent = t; });
  }

  /* ---------- 3) Shop now => apply the 15% code + persistent timer pill ---------- */
  var L = window.localStorage;
  function lget(k){ try { return L.getItem(k); } catch(e){ return null; } }
  function lset(k,v){ try { L.setItem(k, String(v)); } catch(e){} }
  function cookie(k){ var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; }
  function setCookie(k, v, secs){ document.cookie = k + '=' + encodeURIComponent(v) + '; path=/; max-age=' + Math.max(0, Math.round(secs)) + '; SameSite=Lax'; }
  var FS = { exp:'fc_fs_exp', st:'fc_fs_state', min:'fc_fs_min', xs:'fc_fs_ext_end', x40:'fc_fs_x40_exp' };   /* st: active | ext | x40 | ended */
  function x40Exp(){ return lget(FS.st) === 'x40' ? +(lget(FS.x40) || 0) : 0; }
  function fsExp(){ return +(lget(FS.exp) || cookie(FS.exp) || 0); }
  function isOurs(code){ return String(code || '').toUpperCase() === CODE.toUpperCase(); }
  function otherCodes(c){ return ((c && c.discount_codes) || []).map(function(d){ return d.code; }).filter(function(k){ return k && !isOurs(k); }); }
  function rawCart(){ return rawFetch('/cart.js', { headers:{Accept:'application/json'}, credentials:'same-origin' }).then(function(r){ return r.json(); }); }
  function setCodes(list){
    return rawFetch('/cart/update.js', { method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body: JSON.stringify({ discount: list.join(',') }) });
  }
  function applyCode(){
    /* adds OUR code next to any other codes already on the cart (never replaces them) */
    return rawCart().catch(function(){ return {}; }).then(function(c0){ return setCodes(otherCodes(c0).concat([CODE])); })
      .then(function(r){ if (!r.ok) throw r; return r.json(); })
      .then(function(c){
        var ok = (c.discount_codes || []).some(function(d){ return isOurs(d.code); });
        if (!ok) throw new Error('not on cart');
        return 'cart';
      })
      .catch(function(){
        return rawFetch('/discount/' + encodeURIComponent(CODE), { credentials:'same-origin', redirect:'follow' }).then(function(){ return 'cookie'; });
      });
  }
  function removeCode(){
    /* strips ONLY our code; every other code on the cart is kept */
    var p = rawCart().then(function(c){
      var has = (c.discount_codes || []).some(function(d){ return isOurs(d.code); });
      if (!has) return null;
      return setCodes(otherCodes(c));
    }).catch(function(){});
    /* clear the storefront discount cookie too (used by the /discount/CODE fallback), only if it holds our code */
    if (isOurs(cookie('discount_code'))) { document.cookie = 'discount_code=; path=/; max-age=0'; document.cookie = 'discount_code=; path=/; domain=' + location.hostname.replace(/^www\./, '') + '; max-age=0'; }
    return p;
  }
  FC.removeCode = removeCode;
  /* HARD STOPS (Zoran, 11:18 AM MT Oct 24): the code is ALWAYS stripped at 0:00 of the 7-minute coupon AND at 0:00 of
     the 5-minute extension, whatever the cart total. Also enforced on page load (pillBoot) for visitors who come back late. */
  FC.strips = [];
  function stripCode(why){ FC.strips.push({ why: why, at: now() }); return removeCode().then(cartChanged); }
  function onShopNow(e){
    if (!CODE) return;                       /* no code configured: plain link */
    e.preventDefault();
    var href = e.currentTarget.getAttribute('href');
    var remaining = Math.max(0, (+get(K.end) || 0) - now());
    if (remaining <= 0) { set(K.st, 'expired'); stopCoupon(); return; }
    var exp = now() + remaining;
    lset(FS.exp, exp); lset(FS.st, 'active'); setCookie(FS.exp, exp, remaining / 1000 + 60);
    set(K.st, 'clicked');
    var b = e.currentTarget; b.textContent = 'Applying\u2026'; b.setAttribute('aria-disabled', 'true');
    applyCode().then(function(how){
      FC.appliedVia = how; lset('fc_fs_via', how);
      stopCoupon(); pillBoot();
      try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles:true, detail:{ data:{ source:'fc-coupon' } } })); } catch(x){}
      if (href && !/[?&]fc_stay=1/.test(location.search)) location.href = href;
    });
  }
  var pill = null, pillT = null;
  function buildPill(){
    var el = document.createElement('div');
    el.className = 'fc-fs-pill'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'off');
    el.innerHTML = '<span class="fc-fs-pill__txt"><span class="fc-fs-pill__long">15% off toys $' + FC_FREE_SHIP_MIN + '+ ends in </span><span class="fc-fs-pill__short">15% off </span><strong data-fs-clock>7:00</strong></span>' +
      '<button type="button" class="fc-fs-pill__min" aria-label="Minimize timer" aria-expanded="true"><span aria-hidden="true">&minus;</span></button>';
    el.querySelector('.fc-fs-pill__min').addEventListener('click', function(){
      var m = !el.classList.contains('is-min'); el.classList.toggle('is-min', m); lset(FS.min, m ? '1' : '');
      this.setAttribute('aria-expanded', m ? 'false' : 'true'); this.setAttribute('aria-label', m ? 'Expand timer' : 'Minimize timer');
      this.innerHTML = '<span aria-hidden="true">' + (m ? '+' : '&minus;') + '</span>';
    });
    if (lget(FS.min)) { el.classList.add('is-min'); var mb = el.querySelector('.fc-fs-pill__min'); mb.setAttribute('aria-expanded','false'); mb.setAttribute('aria-label','Expand timer'); mb.innerHTML = '<span aria-hidden="true">+</span>'; }
    document.body.appendChild(el);
    return el;
  }
  function endOffer(showMsg, why){
    lset(FS.st, 'ended'); lset('fc_fs_cleaned', '1'); setCookie(FS.exp, '', 0); try { L.removeItem(FS.xs); L.removeItem(FS.x40); } catch(e){}
    if (ext) { var ed = ext; ext = null; hide(ed); }
    if (nd && !nd._plain) stopNudge();
    stripCode(why || 'extension 0:00');                 /* unconditional, even if the eligible subtotal is $40+ */
    clearInterval(pillT); pillT = null;
    if (showMsg) {
      if (!pill) pill = buildPill();
      pill.classList.remove('is-min'); pill.classList.add('is-ended');
      pill.querySelector('.fc-fs-pill__txt').textContent = '15% off offer ended';
      var mb = pill.querySelector('.fc-fs-pill__min'); mb && mb.remove();
      setTimeout(function(){ if (pill) { pill.remove(); pill = null; } }, FC_ENDED_SECONDS * 1000);
    } else if (pill) { pill.remove(); pill = null; }
  }
  function pillTick(){
    var st = lget(FS.st);
    if (st === 'ext') { extTick(); return; }
    if (st === 'x40') { x40Tick(); return; }
    var left = fsExp() - now();
    if (left <= 0) { startExt(); return; }            /* 0:00 => extension message (was: 4 s "ended" note) */
    if (!pill) pill = buildPill();
    pill.querySelector('[data-fs-clock]').textContent = mmss(left);
  }
  function pillMode40(clockMs){
    if (!pill) pill = buildPill();
    if (!pill.classList.contains('is-40')) {
      pill.classList.add('is-40');
      pill.querySelector('.fc-fs-pill__long').textContent = '15% off toys $' + FC_NUDGE_GOAL + '+ ends in ';
      pill.querySelector('.fc-fs-pill__short').textContent = '15% $' + FC_NUDGE_GOAL + '+ ';
    }
    pill.querySelector('[data-fs-clock]').textContent = mmss(clockMs);
  }
  /* ---- clickers at 0:00: extension message for FC_EXT_SECONDS, then the $40 window ---- */
  var ext = null;
  function buildExt(){
    var inner =
      sprout('wait!') +
      '<button type="button" class="fc-pop__x" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
      '<h2 class="fc-pop__h" id="fc-ext-h">' + esc(FC_EXT_HEADER) + '</h2>' +
      '<p class="fc-pop__sub fc-pop__body">' + esc(FC_EXT_BODY) + '</p>' +
      '<button type="button" class="fc-pop__btn" data-ext-go>Keep shopping</button>' + finePrint();
    var dlg = makeDialog('fc-ext', 'Time\'s up', inner);
    dlg.classList.add('fc-pop--ext');
    dlg._dismiss = function(){ startX40(); };
    dlg.querySelector('.fc-pop__x').addEventListener('click', dlg._dismiss);
    dlg.querySelector('[data-ext-go]').addEventListener('click', dlg._dismiss);
    dlg._resume = function(){ show(dlg); };
    return dlg;
  }
  function startExt(){
    if (lget(FS.st) !== 'ext') { lset(FS.st, 'ext'); lset(FS.xs, now() + extSecs * 1000); setCookie(FS.exp, '', 0); stripCode('coupon 0:00'); }   /* 7:00 is up: code off, whatever the cart */
    extTick();
  }
  function extTick(){
    var left = (+lget(FS.xs) || 0) - now();
    if (left <= 0) { startX40(); return; }
    pillMode40(x40Secs * 1000);                        /* pill waits at 5:00 under the message */
    if (!ext && POPUPS) { ext = buildExt(); show(ext); }   /* never on cart/checkout/excluded pages; timing still runs */
    if (!pillT) pillT = setInterval(pillTick, 250);
  }
  function startX40(){
    if (ext) { var d = ext; ext = null; hide(d); }
    if (lget(FS.st) !== 'x40') { lset(FS.st, 'x40'); lset(FS.x40, now() + x40Secs * 1000); }
    x40Tick(); syncCode();
    if (POPUPS && !nudgeDone() && get(K.nst) !== 'open') {
      armIdleNudge();   /* Oct 25: no instant nudge at extension start — same cart+60s idle rule */
    }
  }
  function x40Tick(){
    var left = (+lget(FS.x40) || 0) - now();
    if (left <= 0) { endOffer(false, 'extension 0:00'); return; }   /* end of the 5:00: ALWAYS drop the code, hide pill */
    pillMode40(left);
    if (!pillT) pillT = setInterval(pillTick, 250);
    if (now() - lastSync > 4000) syncCode();
  }
  /* only during the 5:00 extension window (x40): the $35 code is on the cart ONLY while the ELIGIBLE subtotal is $40+.
     Not during the 15 s time's-up message: the code was stripped at the coupon's 0:00. */
  var lastSync = 0, syncing = false;
  function syncCode(){
    var st = lget(FS.st); if (st !== 'x40' || syncing) return;
    if ((+lget(FS.x40) || 0) <= now()) return;
    syncing = true; lastSync = now();
    getCart().then(function(c){
      var has = (c.discount_codes || []).some(function(d){ return isOurs(d.code); });
      var want = subOf(c) >= FC_NUDGE_GOAL * 100;
      FC.x40 = { sub: subOf(c), has: has, want: want };
      if (want && !has) return applyCode().then(function(){
        /* the window may have closed while applying: never leave the code behind */
        if (lget(FS.st) !== 'x40' || (+lget(FS.x40) || 0) <= now()) return stripCode('closed while applying');
        cartChanged();
      });
      if (!want && has) return removeCode().then(cartChanged);
    }).catch(function(){}).then(function(){ syncing = false; });
  }
  function cartChanged(){ try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles:true, detail:{ data:{ source:'fc-coupon' } } })); } catch(x){} }
  FC.syncCode = syncCode;
  function pillBoot(){
    var st = lget(FS.st), exp = fsExp();
    if (st === 'active' && exp && exp <= now()) {
      /* came back after 0:00: replay where we would be */
      /* on-load expiry: the coupon's 0:00 already passed, so strip the code first in every case */
      if (now() < exp + extSecs * 1000) { lset(FS.st, 'ext'); lset(FS.xs, exp + extSecs * 1000); st = 'ext'; stripCode('on load: coupon 0:00 passed'); }
      else if (now() < exp + (extSecs + x40Secs) * 1000) { lset(FS.st, 'x40'); lset(FS.x40, exp + (extSecs + x40Secs) * 1000); stripCode('on load: coupon 0:00 passed').then(syncCode); x40Tick(); return; }
      else { endOffer(false, 'on load: extension 0:00 passed'); return; }
    }
    if (st === 'ext') { extTick(); }
    else if (st === 'x40') { if ((+lget(FS.x40) || 0) <= now()) { endOffer(false, 'on load: extension 0:00 passed'); return; } x40Tick(); syncCode(); }
    else if (st === 'active' && exp) {
      pillTick(); clearInterval(pillT); pillT = setInterval(pillTick, 250);
    } else if (st === 'ended' && !lget('fc_fs_cleaned')) { lset('fc_fs_cleaned', '1'); stripCode('on load: offer ended'); }
  }
  FC.pillBoot = pillBoot;

  /* ---------- boot ---------- */
  function boot(){
    pillBoot();
    if (!POPUPS) return;
    /* Drop any ndue leftover from the old "15s/45s after coupon dismiss" rule */
    if (get(K.ndue) && get(K.nst) !== 'open') del(K.ndue);
    if (debug === 'now' && !couponDone() && get(K.st) !== 'clicked') { set(K.ms, FC_POPUP_DELAY_SECONDS * 1000); startCoupon(); }
    else if (get(K.st) === 'open') startCoupon();                /* resume running countdown on a new page */
    if (debug === 'nudge') { if (get(K.nst) !== 'open') del(K.nst); getCart().then(function(c){ startNudge(c); }); }
    else if (get(K.nst) === 'open') startNudge();
    else armIdleNudge();                                         /* if cart already has items, start 60s idle clock */
    setInterval(tick, 1000);
    tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
